import { Button } from "antd";
import arrowOut from "images/arrow-out.svg";

export const ReturnButton = ({
  onClick,
  disabled,
  loading,
  className = "bg-basic-300",
}: {
  onClick: () => void;
  disabled: boolean;
  loading: boolean;
  className?: string;
}) => {
  return (
    <Button
      type="text"
      variant="filled"
      icon={<img src={arrowOut} alt="arrow-out" />}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      className={className}
    />
  );
};
